export default __webpack_public_path__ + "static/media/p16.af7a1e22.jpg";